import { render, staticRenderFns } from "./qra.vue?vue&type=template&id=066cc948"
import script from "./qra.vue?vue&type=script&lang=js"
export * from "./qra.vue?vue&type=script&lang=js"
import style0 from "./qra.vue?vue&type=style&index=0&id=066cc948&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports